// -------------------------------------------------------------------- constants --------------------------------------------------------------------

// ********************************************************************* meals **********************************************************************
const INDEX_FEED_MEALS_SUCCESS = "INDEX_FEED_MEALS_SUCCESS";
const SHOW_FEED_MEAL_SUCCESS = "SHOW_FEED_MEAL_SUCCESS";
const STORE_FEED_MEAL_SUCCESS = "STORE_FEED_MEAL_SUCCESS";
const UPDATE_FEED_MEAL_SUCCESS = "UPDATE_FEED_MEAL_SUCCESS";
const DESTROY_FEED_MEAL_SUCCESS = "DESTROY_FEED_MEAL_SUCCESS";

// ----------------------------------------------------------------< action creators >----------------------------------------------------------------

// ********************************************************************* meals **********************************************************************
/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _indexSuccess(payload) {
  return {
    type: INDEX_FEED_MEALS_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _showSuccess(payload) {
  return {
    type: SHOW_FEED_MEAL_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _storeSuccess(payload) {
  return {
    type: STORE_FEED_MEAL_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _updateSuccess(payload) {
  return {
    type: UPDATE_FEED_MEAL_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {Number} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _destroySuccess(payload) {
  return {
    type: DESTROY_FEED_MEAL_SUCCESS,
    payload: payload,
  };
}

// --------------------------------------------------------------------< actions >--------------------------------------------------------------------

// ********************************************************************* meals **********************************************************************

/**
 *
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function index(params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("Meal@index") || app.can("Reserve@index")) {
      api
        .get("/feeding/meals", { params })
        .then((res) => {
          dispatch(_indexSuccess(res));
          callback(undefined, res);
        })
        .catch((err) => {
          app.error(
            err,
            "routes.home.feed",
            ".خطا در دریافت اطلاعات! لطفا مجدد تلاش کنید",
            app.translate("routes.home.feed.Indexing Meals Failed")
          );
          callback(err);
        });
    } else {
      callback(undefined);
      app.message(
        app.translate(
          "routes.permission error",
          {
            permission: `${app.translate(
              "routes.home.basic.permission.Meal",
              "Meal"
            )} - ${app.translate(
              "routes.home.basic.permission.index",
              "index"
            )}`,
          },
          "permission error"
        ),
        "error"
      );
    }
  };
}

/**
 *
 * @return {{type: String, payload: Object}}
 */
export function emptyMeals() {
  return _indexSuccess({ data: { meals: [] }, meta: {} });
}

/**
 *
 * @param {Number} meal
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function show(meal, params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("Meal@index")) {
      api
        .get(`/feeding/meals/${meal}`, { params })
        .then((res) => {
          dispatch(_showSuccess(res));
          callback(undefined, res);
        })
        .catch((err) => {
          app.error(
            err,
            "routes.home.feed",
            ".خطا در دریافت اطلاعات! لطفا مجدد تلاش کنید",
            app.translate("routes.home.feed.Indexing Meal Failed")
          );
          callback(err);
        });
    } else {
      callback(undefined);
      app.message(
        app.translate(
          "routes.permission error",
          {
            permission: `${app.translate(
              "routes.home.basic.permission.Meal",
              "Meal"
            )} - ${app.translate(
              "routes.home.basic.permission.index",
              "index"
            )}`,
          },
          "permission error"
        ),
        "error"
      );
    }
  };
}

/**
 *
 * @return {{type: String, payload: Object}}
 */
export function emptyMeal() {
  return _showSuccess({ data: { meal: {} }, meta: {} });
}

/**
 *
 * @param {Object} data
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function store(data, params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("Meal@store")) {
      let loader = app.loading(
        app.translate("routes.home.feed.Adding New Meal")
      );

      api
        .post("/feeding/meals", { data: { meal: data }, params })
        .then((res) => {
          dispatch(_storeSuccess(res));
          loader.hide(() =>
            app.message(
              app.translate("routes.home.feed.New Meal Added Successfully")
            )
          );
          callback(undefined, res);
        })
        .catch((err) => {
          loader.hide(() =>
            app.error(
              err,
              "routes.home.feed",
              "خطا در ارسال اطلاعات",
              app.translate("routes.home.feed.Adding New Meal Failed")
            )
          );
          callback(err);
        });
    } else {
      callback(undefined);
      app.message(
        app.translate(
          "routes.permission error",
          {
            permission: `${app.translate(
              "routes.home.basic.permission.Meal",
              "Meal"
            )} - ${app.translate(
              "routes.home.basic.permission.store",
              "store"
            )}`,
          },
          "permission error"
        ),
        "error"
      );
    }
  };
}

/**
 *
 * @param {Number} meal
 * @param {Object} data
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function update(meal, data, params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("Meal@update")) {
      let loader = app.loading(app.translate("routes.home.feed.Updating Meal"));

      api
        .put(`/feeding/meals/${meal}`, { data: { meal: data }, params })
        .then((res) => {
          dispatch(_updateSuccess(res));
          loader.hide(() =>
            app.message(
              app.translate("routes.home.feed.Meal Updated Successfully")
            )
          );
          callback(undefined, res);
        })
        .catch((err) => {
          loader.hide(() =>
            app.error(
              err,
              "routes.home.feed",
              "عملیات بروزرسانی با شکست مواجه شد",
              app.translate("routes.home.feed.Updating Meal Failed")
            )
          );
          callback(err);
        });
    } else {
      callback(undefined);
      app.message(
        app.translate(
          "routes.permission error",
          {
            permission: `${app.translate(
              "routes.home.basic.permission.Meal",
              "Meal"
            )} - ${app.translate(
              "routes.home.basic.permission.update",
              "update"
            )}`,
          },
          "permission error"
        ),
        "error"
      );
    }
  };
}

/**
 *
 * @param {Number} meal
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function destroy(meal, params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("Meal@destroy")) {
      let loader = app.loading(app.translate("routes.home.feed.Removing Meal"));

      api
        .delete(`/feeding/meals/${meal}`, { params })
        .then((res) => {
          dispatch(_destroySuccess(meal));
          loader.hide(() =>
            app.message(
              app.translate("routes.home.feed.Meal Removed Successfully")
            )
          );
          callback(undefined, res);
        })
        .catch((err) => {
          loader.hide(() =>
            app.error(
              err,
              "routes.home.feed",
              "عملیات حذف با شکست مواجه شد",
              app.translate("routes.home.feed.Removing Meal Failed")
            )
          );
          callback(err);
        });
    } else {
      callback(undefined);
      app.message(
        app.translate(
          "routes.permission error",
          {
            permission: `${app.translate(
              "routes.home.basic.permission.Meal",
              "Meal"
            )} - ${app.translate(
              "routes.home.basic.permission.destroy",
              "destroy"
            )}`,
          },
          "permission error"
        ),
        "error"
      );
    }
  };
}

// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------
/**
 *
 * @param {Object} state
 * @param {{type: String, payload: Object}} action
 * @return {Object}
 */
export default function reducer(
  state = {
    meals: [],
    meal: {},
    meta: {},
  },
  action
) {
  let meals;
  let _index;
  switch (action.type) {
    case INDEX_FEED_MEALS_SUCCESS:
      return Object.assign({}, state, {
        meals: action.payload.data.meals,
        meta: action.payload.meta,
      });
    case SHOW_FEED_MEAL_SUCCESS:
      return Object.assign({}, state, {
        meal: action.payload.meal,
      });
    case STORE_FEED_MEAL_SUCCESS:
      meals = app._.cloneDeep(state.meals);
      meals.push(action.payload);
      return Object.assign({}, state, {
        meals,
      });
    case UPDATE_FEED_MEAL_SUCCESS:
      meals = app._.cloneDeep(state.meals);
      _index = meals.findIndex((_meal) => _meal.id === action.payload.id);
      meals[_index] = action.payload;
      return Object.assign({}, state, {
        meals,
      });
    case DESTROY_FEED_MEAL_SUCCESS:
      meals = app._.cloneDeep(state.meals);
      _index = meals.findIndex((_meal) => _meal.id === action.payload);
      meals.splice(_index, 1);
      return Object.assign({}, state, {
        meals,
      });
    default:
      return state;
  }
}
